import { Link } from "react-router-dom";
import { useSubscription } from "@/context/SubscriptionContext";
import { useAuth } from "@/context/AuthContext";
import { fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { CalendarX } from "@phosphor-icons/react";

const dayStart = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
export const calendarDaysLeft = (iso) => Math.round((dayStart(new Date(iso)) - dayStart(new Date())) / 86400000);

export function RenewalBanner() {
  const { entitlement: e } = useSubscription();
  const { user } = useAuth();
  if (!e || e.state !== "active" || e.provider === "stripe" || !e.end_date) return null;
  const days = calendarDaysLeft(e.end_date);
  if (days > 7 || days < 0) return null;
  const canPay = ["owner", "admin"].includes(user?.role);
  const when = days === 0 ? "termina hoje" : days === 1 ? "termina amanhã" : `termina dentro de ${days} dias`;
  return (
    <div className="flex flex-wrap items-center gap-4 rounded-xl border border-amber-300 bg-amber-50 p-4 text-amber-900" data-testid="renewal-banner">
      <CalendarX size={26} weight="duotone" className="shrink-0" />
      <div className="flex-1 text-sm">
        <div className="font-semibold" data-testid="renewal-banner-text">O seu plano {e.plan_name} {when} ({fmtDate(e.end_date)}).</div>
        <div className="text-amber-800">{canPay ? "Renove agora para continuar sem interrupções." : "Peça ao proprietário da conta para renovar o plano."}</div>
      </div>
      {canPay && (
        <Button className="rounded-full bg-petrol text-white hover:bg-petrol/90" asChild data-testid="renewal-banner-btn">
          <Link to="/o-meu-plano?renovar=1">Renovar plano</Link>
        </Button>
      )}
    </div>
  );
}
